<template lang="pug">
  el-container
    el-header(height="auto")
      el-form(:model="form" inline label-suffix=":" ref="form")
        el-form-item(label="角色" prop="role")
          el-input(v-model="form.role")
        el-form-item(label="城市" prop="cityName")
          el-input(v-model="form.cityName")
        el-form-item
          el-button(
            type="primary"
            icon="el-icon-search"
            :loading="searching"
            @click="search"
          ) 搜索
          reset-button(:remoteMethod="search")
          el-button(
            type="success"
            icon="el-icon-plus"
            @click="showPermission()"
          ) 新增角色
    el-main
      grid(:remoteMethod="getTableData" ref="grid")
        el-table-column(prop="roleDescription" label="角色")
        el-table-column(
          :formatter="row => row.cityName.toString()"
          label="城市"
          show-overflow-tooltip
        )
        el-table-column(prop="allocate" label="已分配账号")
        el-table-column(prop="updateTime" label="更新时间")
        el-table-column(label="操作" width="140")
          template(slot-scope="scope")
            el-button(type="text" @click="showPermission(scope.row)") 修改角色
      el-dialog(
        title="角色信息"
        width="30%"
        :visible.sync="permissionDialogVisible"
      )
        permission-tree(
          :data="role"
          v-if="permissionDialogVisible"
          @submit="permissionSubmit"
        )
</template>

<script>
import { getRoleList } from '@/api/user';
import grid from '@/components/grid';
import resetButton from '@/components/resetButton';
import permissionTree from './permissionTree';

export default {
  name: 'RoleList',
  components: {
    grid,
    permissionTree,
    resetButton
  },
  data() {
    return {
      form: {
        role: '',
        cityName: '',
      },
      role: {},
      searching: false,
      permissionDialogVisible: false
    };
  },
  mounted() {
    this.search();
  },
  methods: {
    async getTableData(data) {
      const res = await getRoleList(data);
      return { data: res.data, total: res.total };
    },
    async search() {
      this.searching = true;
      await this.$refs.grid.loadData(this.form);
      this.searching = false;
    },
    showPermission(role) {
      this.role = role;
      this.permissionDialogVisible = true;
    },
    permissionSubmit() {
      this.permissionDialogVisible = false;
      this.search();
    },
  },
};
</script>

<style lang="scss" scoped>
.green{
  font-size: 18px;
  color: #67c23a;
}
.red{
  font-size: 18px;
  color: #dd454d;
}
</style>



// WEBPACK FOOTER //
// src/views/system/role.vue?407dbf21